import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductScreenshotModule } from './product-screenshot/product-screenshot.module';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsNavComponent } from './products-nav/products-nav.component';
import { ProductsComponent } from './products.component';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, ProductsRoutingModule, ProductScreenshotModule],
  declarations: [ProductsComponent, ProductDetailComponent, ProductsNavComponent],
})
export class ProductsModule {}
